"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var context_1 = require("../../../context");
var Checkbox_1 = __importDefault(require("../../Checkbox"));
var FormControl_1 = __importDefault(require("../../FormControl"));
var CommunicationPreferencesInput = function () {
    var trans = context_1.useSemantics().trans;
    var errors = formik_1.useFormikContext().errors;
    return (react_1.default.createElement(FormControl_1.default, { errors: errors.communication_preferences, dusk: "communication-preferences-field", label: trans('optiiva::labels.communication-preferences') },
        react_1.default.createElement("div", { className: "flex flex-col" },
            react_1.default.createElement(Checkbox_1.default, { dusk: "communication-preferences", name: "communication_preferences", label: trans('optiiva::labels.phone'), value: "phone" }),
            react_1.default.createElement(Checkbox_1.default, { dusk: "communication-preferences", name: "communication_preferences", label: trans('optiiva::labels.email'), value: "email" }),
            react_1.default.createElement(Checkbox_1.default, { dusk: "communication-preferences", name: "communication_preferences", label: trans('optiiva::labels.sms'), value: "sms" }),
            react_1.default.createElement(Checkbox_1.default, { dusk: "communication-preferences", name: "communication_preferences", label: trans('optiiva::labels.post'), value: "post" }))));
};
exports.default = CommunicationPreferencesInput;
//# sourceMappingURL=CommunicationPreferencesInput.js.map